import React from 'react';
import { CheckCircle2Icon, BarChartIcon } from 'lucide-react';
const WinMoreBids = () => {
  return <div className="py-20 bg-white overflow-hidden" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="flex flex-col lg:flex-row-reverse items-center gap-12" data-id="element-284">
          {/* Text Content */}
          <div className="lg:w-1/2" data-id="element-285">
            <h2 className="text-sm text-accent font-bold tracking-widest uppercase" data-id="element-286">
              Competitive Intelligence
            </h2>
            <h3 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-customblack sm:text-4xl" data-id="element-287">
              Outrank Competitors in AI Search
            </h3>
            <p className="mt-4 text-lg text-customgray" data-id="element-288">
              Understand how competitors appear in AI-generated answers and find
              opportunities to win more visibility.
            </p>
            <div className="mt-8" data-id="element-289">
              <ul className="space-y-5" data-id="element-290">
                {['Side-by-side competitor visibility comparisons', "Identify gaps where competitors are cited but you aren't", 'Track share of voice across AI search engines', 'Benchmark your AEO/GEO performance over time'].map((item, i) => <li key={i} className="flex items-start" data-id="element-291">
                    <div className="flex-shrink-0 mt-0.5" data-id="element-292">
                      <CheckCircle2Icon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-293" />
                    </div>
                    <p className="ml-3 text-base text-customgray font-medium" data-id="element-294">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Mockup */}
          <div className="lg:w-1/2 w-full" data-id="element-295">
            <div className="relative mx-auto w-full max-w-lg rounded-2xl bg-surface border border-gray-800 shadow-2xl overflow-hidden" data-id="element-296">
              {/* Mockup Header */}
              <div className="bg-primary/80 border-b border-gray-800 px-6 py-5" data-id="element-297">
                <h4 className="text-white font-semibold flex items-center" data-id="element-298">
                  <BarChartIcon className="w-4 h-4 mr-2 text-textlight" data-id="element-299" />
                  Share of Voice (AI Search)
                </h4>
                <p className="text-xs text-textlight mt-1" data-id="element-300">
                  Category: Enterprise Software
                </p>
              </div>

              {/* Mockup Content */}
              <div className="p-6 space-y-6 bg-gradient-to-b from-surface to-primary/30" data-id="element-301">
                {/* Prism Bar */}
                <div data-id="element-302">
                  <div className="flex justify-between text-sm mb-2" data-id="element-303">
                    <span className="text-white font-semibold flex items-center" data-id="element-304">
                      <div className="w-2 h-2 rounded-full bg-accent mr-2" data-id="element-305"></div>
                      Your Brand
                    </span>
                    <span className="text-accent font-bold" data-id="element-306">42%</span>
                  </div>
                  <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden border border-gray-700" data-id="element-307">
                    <div className="bg-accent h-3 rounded-full relative" data-id="element-308">
                      <div className="absolute inset-0 bg-white/20 w-full h-full animate-pulse" data-id="element-309"></div>
                    </div>
                  </div>
                </div>

                {/* Competitor A */}
                <div data-id="element-310">
                  <div className="flex justify-between text-sm mb-2" data-id="element-311">
                    <span className="text-gray-300 flex items-center" data-id="element-312">
                      <div className="w-2 h-2 rounded-full bg-gray-500 mr-2" data-id="element-313"></div>
                      Competitor A
                    </span>
                    <span className="text-gray-400 font-medium" data-id="element-314">28%</span>
                  </div>
                  <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden border border-gray-700" data-id="element-315">
                    <div className="bg-gray-500 h-3 rounded-full" style={{
                    width: '66%'
                  }} data-id="element-316"></div>
                  </div>
                </div>

                {/* Competitor B */}
                <div data-id="element-317">
                  <div className="flex justify-between text-sm mb-2" data-id="element-318">
                    <span className="text-gray-300 flex items-center" data-id="element-319">
                      <div className="w-2 h-2 rounded-full bg-gray-600 mr-2" data-id="element-320"></div>
                      Competitor B
                    </span>
                    <span className="text-gray-400 font-medium" data-id="element-321">18%</span>
                  </div>
                  <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden border border-gray-700" data-id="element-322">
                    <div className="bg-gray-600 h-3 rounded-full" style={{
                    width: '42%'
                  }} data-id="element-323"></div>
                  </div>
                </div>

                {/* Others */}
                <div data-id="element-324">
                  <div className="flex justify-between text-sm mb-2" data-id="element-325">
                    <span className="text-gray-400 flex items-center" data-id="element-326">
                      <div className="w-2 h-2 rounded-full bg-gray-700 mr-2" data-id="element-327"></div>
                      Others
                    </span>
                    <span className="text-gray-500 font-medium" data-id="element-328">12%</span>
                  </div>
                  <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden border border-gray-700" data-id="element-329">
                    <div className="bg-gray-700 h-3 rounded-full" style={{
                    width: '28%'
                  }} data-id="element-330"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default WinMoreBids;